const Errors = require('./errors.js');
const Fields = require('./fields.js');
const Brands = require('./brands.js');

function Validator() {}

// Card Validation 

function isValidCardNumber(cardNumber) {
  if (cardNumber && (cardNumber.toString().trim())) {
    cardNumber = cardNumber.toString().replace(/\s/g, '');

    let cardBrand = Brands.cardBrand(cardNumber);
    if (cardBrand.cardPattern) {
      return cardBrand.cardPattern.test(cardNumber);
    }
  }

  return false;
}

function isValidLength(cardNumber, cardBrand) {
  if (cardNumber && (cardNumber.toString().trim()) && cardBrand && cardBrand.lengths) {
    cardNumber = cardNumber.toString().replace(/\s/g, '');

    for (let i = 0, lengths = cardBrand.lengths.length; i < lengths; i++) {
      if (cardNumber.length == cardBrand.lengths[i]) {
        return true;
      }
    }
  }
  return false;
}

function isValidLuhn(cardNumber) {
  if (cardNumber && (cardNumber.toString().trim())) {
    cardNumber = cardNumber.toString().replace(/\s/g, '');
    let sum = 0;
    let alternate = false;
    for (let i = cardNumber.length - 1; i >= 0; i--) {
      let n = parseInt(cardNumber.substring(i, i + 1));
      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }
      sum += n;
      alternate = !alternate;
    }
    return ((sum % 10) === 0);
  }
  return false;
}

Validator.prototype.validateCardNumber = function(cardNumber, acceptedBrands) {
  if (cardNumber && (cardNumber.toString().trim())) {
    cardNumber = cardNumber.toString().replace(/\s/g, '');

    let cardBrand = Brands.cardBrand(cardNumber);
    if (cardBrand.brand === Brands.Names.Unknown) {
      return {
        isValid: false,
        error: Errors.errorDetails(Fields.CARD_NUMBER, Errors.CardNumberInvalid),
      };
    } else if (!isValidLength(cardNumber, cardBrand)) {
      return {
        isValid: false,
        error: Errors.errorDetails(Fields.CARD_NUMBER, Errors.CardNumberInvalid),
      };
    } else if (!isValidCardNumber(cardNumber)) {
      return {
        isValid: false,
        error: Errors.errorDetails(Fields.CARD_NUMBER, Errors.CardNumberInvalid),
      };
    } else if (!isValidLuhn(cardNumber)) {
      return {
        isValid: false,
        error: Errors.errorDetails(Fields.CARD_NUMBER, Errors.CardNumberInvalid),
      };
    } else if (acceptedBrands && acceptedBrands.indexOf(cardBrand.brand) < 0) {
      return {
        isValid: false, 
        error: Errors.errorDetails(Fields.CARD_NUMBER, Errors.CardNumberInvalid),
      }; 
    } else {
      return {
        isValid: true,
      };
    }
  }

  return {
    isValid: false,
    error: Errors.errorDetails(Fields.CARD_NUMBER, Errors.CardNumberInvalid),
  };
};


// cvv validation 

Validator.prototype.validateCvv = function(cvv, cardBrand) {
  if (cvv && (cvv.toString().trim())) {
    cvv = cvv.toString().replace(/\s/g, '');

    let length = 4;
    length = (cardBrand && cardBrand.cvvLength) ? cardBrand.cvvLength : length;

    if ((cvv.length !== length)) {
      return {
        isValid: false,
        error: Errors.errorDetails(Fields.CVV, Errors.CvvNotSet),
      };
    } else if (isNaN(cvv)) {
      return {
        isValid: false,
        error: Errors.errorDetails(Fields.CVV, Errors.CvvNotSet),
      };
    } else {
      return {
        isValid: true,
      };
    }
  }
  return {
    isValid: false,
    error: Errors.errorDetails(Fields.CVV, Errors.CvvNotSet),
  };
};

// expiry validation 

function isValidExpiryField(expiryField) {
  let expiryLength = 2;

  if (expiryField && (expiryField.toString().trim())) {
    expiryField = expiryField.toString().replace(/\s/g, '');
    return (expiryField.length === expiryLength) && !isNaN(expiryField);
  }
}

function isValidMonth(month) {
  if (isValidExpiryField(month)) {
    let january = 1;
    let december = 12;
    month = parseInt(month);
    return (month >= january && month <= december);
  }
}

function isValidExpiry(month, year) {
  if (isValidExpiryField(month) && isValidExpiryField(year) && isValidMonth(month)) {

    let today = new Date();
    let expiry = new Date();

    year = 2000 + parseInt(year);
    month = parseInt(month);
    expiry.setFullYear(year, month - 1, today.getDate());

    if (expiry >= today) {
      return true;
    }
  }
  return false;
}

Validator.prototype.validateExpiry = function(expiry) {
  
  let month;
  let year;
  if (!expiry) {
    month = '';
    year = '';
  } else {
    const monthYear = expiry.split(' / ');
    if (!monthYear || monthYear.length !== 2) {
      month = '';
      year = '';
    } else {
      month = monthYear[0];
      year = monthYear[1];
    }
  }

  if (isValidExpiryField(month) && isValidExpiryField(year) ) {
    month = month.toString().replace(/\s/g, '');
    year = year.toString().replace(/\s/g, '');
    if (!isValidMonth(month)) {
      return {
        isValid: false,
        error: Errors.errorDetails(Fields.EXPIRY, Errors.ExpiryIsNotSet),
      };
    } else if (isValidExpiry(month, year)) {
      return {
        isValid: true,
      };
    } else {
      return {
        isValid: false,
        error: Errors.errorDetails(Fields.EXPIRY, Errors.ExpiryIsInThePast),
      };
    }
  } else {
    return {
      isValid: false,
      error: Errors.errorDetails(Fields.EXPIRY, Errors.ExpiryIsNotSet),
    };
  }
};

module.exports = Validator;


// WEBPACK FOOTER //
// ./app/validator.js